import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

import { useDisclosure, UseDisclosureReturn } from '@chakra-ui/react';

import { ColumnModal } from '../components/ColumnModal';

interface ColumnModalProviderProps {
  children: ReactNode;
}

interface IColumnModalData extends UseDisclosureReturn {
  selectedColumnId: (value: string) => void;
}

const ColumnModalContext = createContext({} as IColumnModalData);

export function ColumnModalProvider({ children }: ColumnModalProviderProps) {
  const disclosure = useDisclosure();
  const [columnId, setColumnId] = useState<string>('');

  const selectedColumnId = useCallback((value: string) => {
    setColumnId(value);
  }, []);

  return (
    <ColumnModalContext.Provider value={{ ...disclosure, selectedColumnId }}>
      {children}
      <ColumnModal columnId={columnId} />
    </ColumnModalContext.Provider>
  );
}

export const useColumnModal = () => useContext(ColumnModalContext);
